define('app/sds/report/category/menu/sds-report-category-menu-service',["service!selcomm", "$q"], function (SelcommWS, $q) {
	"use strict";
	var ReportCategoryList = SelcommWS.prepare.cached.post("Reports", "ReportCategoryList");
	return function sdsCategoryMenuService(select) {
		return $q(function ($return, $throw) {
			ReportCategoryList({})
				.then(function (reportCategories) {
					$return((reportCategories.Items || reportCategories).map(function (reportCategory) {
						return {
							ImageUrl: reportCategory.ImageUrl,
							Id: reportCategory.Id,
							Caption: reportCategory.Name,
							Command: "menu-factory=service!sds-report-definition-menu",
							CommandText: "menu-factory=service!sds-report-definition-menu"
						};
					}));
				})
				.catch(function (err) {
					$throw(err);
				});
		});
	}
});
